import { useParams, useNavigate } from 'react-router-dom';
import { Card, Spin } from '@/shared/ui/primitives';
import { useTranslation } from 'react-i18next';
import PageHeader from '@/shared/components/PageHeader';
import HousingStatusForm from '../components/HousingStatusForm';
import { useHousingStatusDetails } from '../hooks/useHousingStatusQueries';
import { useUpdateHousingStatus } from '../hooks/useHousingStatusMutations';

export default function HousingStatusEditPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { data, isLoading: loadingDetails } = useHousingStatusDetails(id);
  const mutation = useUpdateHousingStatus();
  const handleSubmit = (formData: any) => { (mutation.mutate as any)({ id, data: formData }, { onSuccess: () => navigate('/housing-statuses') }); };

  if (loadingDetails) return <Spin style={{ display: 'block', margin: '80px auto' }} />;

  return (
    <div>
      <PageHeader back title={t('housingStatuses.editTitle')} subtitle={`${t('common.editing')}: ${data?.nameEn || ''}`} />
      <Card><HousingStatusForm initialData={data} onSubmit={handleSubmit} isLoading={mutation.isPending} /></Card>
    </div>
  );
}
